import { Fragment } from 'react';

export type StepDef<StepId extends string = string> = {
  id: StepId;
  label: string;
};

export interface StepperProps<StepId extends string = string> {
  steps: ReadonlyArray<StepDef<StepId>>;
  activeStep: StepId;
  onStepClick: (step: StepId) => void;
  ariaLabel?: string;
}

export default function Stepper<StepId extends string>({
  steps,
  activeStep,
  onStepClick,
  ariaLabel = 'Form steps',
}: StepperProps<StepId>) {
  const activeIndex = steps.findIndex((s) => s.id === activeStep);

  return (
    <div className="flow-stepper" role="tablist" aria-label={ariaLabel}>
      {steps.map((step, index) => {
        const isActive = step.id === activeStep;
        const isDone = index < activeIndex;
        return (
          <Fragment key={step.id}>
            <button
              type="button"
              role="tab"
              aria-selected={isActive}
              data-step={index + 1}
              className={`flow-stepper__step${isActive ? ' flow-stepper__step--active' : ''}${isDone ? ' flow-stepper__step--done' : ''}`}
              onClick={() => onStepClick(step.id)}
            >
              {step.label}
            </button>
            {index < steps.length - 1 && (
              <span className={`flow-stepper__line${index < activeIndex ? ' flow-stepper__line--done' : ''}`} />
            )}
          </Fragment>
        );
      })}
    </div>
  );
}

